import qs from 'qs';
import { Maybe, ObjectType } from '@csp/csp-common-model';

const stringifyQueryParams = <TData extends ObjectType>(obj: TData): string =>
  qs.stringify(obj, {
    encode: false,
  });
const parseQueryParams = <TData extends ObjectType>(str: string): TData =>
  qs.parse(str, {
    ignoreQueryPrefix: true,
    decoder: (str, _defaultDecoder, _charset, type) => {
      if (type === 'value') {
        if (Number(str) || str === '0') {
          return Number(str);
        }
        // if str contains boolean then return boolean
        if (str.match(/^(true|false)$/)) {
          return str === 'true';
        }
      }

      return str;
    },
    arrayLimit: 99999999,
  }) as TData;

/** Combines url path with given query param search string. */
const addQueryParamsToPath = (path: Maybe<string>, search: string): string => {
  if (!search || !path) {
    return path ?? '';
  } else {
    const url = path.split('?');
    const pathWithSearchParams = url[0] ? `${url[0]}${search}` : path;
    return pathWithSearchParams;
  }
};

const getDomainNameFromUrl = (url: string): string => {
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace('www.', '');
  } catch (error) {
    console.debug('Could not parse url', error);
    return '';
  }
};
export const UrlUtil = {
  stringifyQueryParams,
  parseQueryParams,
  addQueryParamsToPath,
  getDomainNameFromUrl,
};
